/* helpers/fechas.js ------------------------------------------------------- */
import dayjs from 'dayjs'

/**
 * Devuelve el penúltimo día hábil (lu-vi) del mes YYYY-MM
 * @param {Number} year   – ej. 2025
 * @param {Number} month  – 1-12
 * @param {String[]} feriadosISO – array 'YYYY-MM-DD' opcional
 * @returns {dayjs.Dayjs}
 */
export function penultimoDiaHabil (year, month, feriadosISO = []) {
  let d = dayjs(`${year}-${String(month).padStart(2, '0')}-01`).endOf('month')
  let hábiles = 0

  while (true) {
    const esFinde    = d.day() === 0 || d.day() === 6
    const esFeriado  = feriadosISO.includes(d.format('YYYY-MM-DD'))

    if (!esFinde && !esFeriado) {
      hábiles++
      if (hábiles === 2) return d             // segundo hábil encontrado
    }
    d = d.subtract(1, 'day')
  }
}
